/**
 * Generated runtime TestId mirror for frontend/src/features/notifications/NotificationHistory.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const NotificationHistoryTestIds = {
  colDate: "col-date",
  colEventType: "col-event-type",
  colMessage: "col-message",
  colReadIndicator: "col-read-indicator",
  notificationHistoryTitle: "notification-history-title",
  notificationEventType: (notification_id: string) => `notification-event-type-${notification_id}`,
  notificationEventTypePrefix: () => "notification-event-type-" as TestIdPrefix,
  notificationMessage: (notification_id: string) => `notification-message-${notification_id}`,
  notificationMessagePrefix: () => "notification-message-" as TestIdPrefix,
  notificationRow: (notification_id: string) => `notification-row-${notification_id}`,
  notificationRowPrefix: () => "notification-row-" as TestIdPrefix
} as const;
